/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const REPORT_CLEAN_REQUEST = 'REPORT_CLEAN_REQUEST';

export const REPORT_GENERATE_REQUEST = 'REPORT_GENERATE_REQUEST';
export const REPORT_GENERATE_REQUEST_SUCCESS = 'REPORT_GENERATE_REQUEST_SUCCESS';
export const REPORT_GENERATE_REQUEST_FAILURE = 'REPORT_GENERATE_REQUEST_FAILURE';

export const TAX_GROUP_LIST_REQUEST = 'TAX_GROUP_LIST_REQUEST';
export const TAX_GROUP_LIST_REQUEST_SUCCESS = 'TAX_GROUP_LIST_REQUEST_SUCCESS';
export const TAX_GROUP_LIST_REQUEST_FAILURE = 'TAX_GROUP_LIST_REQUEST_FAILURE';

export const REPORT_MODULE_FETCH_REQUEST = ' REPORT_MODULE_FETCH_REQUEST';
export const REPORT_MODULE_FETCH_REQUEST_SUCCESS = ' REPORT_MODULE_FETCH_REQUEST_SUCCESS';
export const REPORT_MODULE_FETCH_REQUEST_FAILURE = ' REPORT_MODULE_FETCH_REQUEST_FAILURE';

export const REPORT_COLUMNS_FETCH_REQUEST = 'REPORT_COLUMNS_FETCH_REQUEST';
export const REPORT_COLUMNS_FETCH_REQUEST_SUCCESS = 'REPORT_COLUMNS_FETCH_REQUEST_SUCCESS';
export const REPORT_COLUMNS_FETCH_REQUEST_FAILURE = 'REPORT_COLUMNS_FETCH_REQUEST_FAILURE';

export const REPORT_COLUMNS_OPERATOR_FETCH_REQUEST = 'REPORT_COLUMNS_OPERATOR_FETCH_REQUEST';
export const REPORT_COLUMNS_OPERATOR_FETCH_REQUEST_SUCCESS =
  'REPORT_COLUMNS_OPERATOR_FETCH_REQUEST_SUCCESS';
export const REPORT_COLUMNS_OPERATOR_FETCH_REQUEST_FAILURE =
  'REPORT_COLUMNS_OPERATOR_FETCH_REQUEST_FAILURE';

export const REPORT_GENERATED_FETCH_REQUEST = 'REPORT_GENERATED_FETCH_REQUEST';
export const REPORT_GENERATED_FETCH_REQUEST_SUCCESS = 'REPORT_GENERATED_FETCH_REQUEST_SUCCESS';
export const REPORT_GENERATED_FETCH_REQUEST_FAILURE = 'REPORT_GENERATED_FETCH_REQUEST_FAILURE';

// Save Report
export const REPORT_SAVE_REQUEST = 'REPORT_SAVE_REQUEST';
export const REPORT_SAVE_REQUEST_SUCCESS = 'REPORT_SAVE_REQUEST_SUCCESS';
export const REPORT_SAVE_REQUEST_FAILURE = 'REPORT_SAVE_REQUEST_FAILURE';

// Export Report
export const REPORT_EXPORT_REQUEST = 'REPORT_EXPORT_REQUEST';
export const REPORT_EXPORT_REQUEST_SUCCESS = 'REPORT_EXPORT_REQUEST_SUCCESS';
export const REPORT_EXPORT_REQUEST_FAILURE = 'REPORT_EXPORT_REQUEST_FAILURE';

// Saved Report List
export const SAVED_REPORT_LIST_FETCH_REQUEST = 'SAVED_REPORT_LIST_FETCH_REQUEST';
export const SAVED_REPORT_LIST_FETCH_REQUEST_SUCCESS = 'SAVED_REPORT_LIST_FETCH_REQUEST_SUCCESS';
export const SAVED_REPORT_LIST_FETCH_REQUEST_FAILURE = 'SAVED_REPORT_LIST_FETCH_REQUEST_FAILURE';

// Delete Saved Report
export const SAVED_REPORT_DELETE_REQUEST = 'SAVED_REPORT_DELETE_REQUEST';
export const SAVED_REPORT_DELETE_REQUEST_SUCCESS = 'SAVED_REPORT_DELETE_REQUEST_SUCCESS';
export const SAVED_REPORT_DELETE_REQUEST_FAILURE = 'SAVED_REPORT_DELETE_REQUEST_FAILURE';

// Reset saved report load state
export const SAVED_REPORT_RESET = 'SAVED_REPORT_RESET';
